import withModules from 'cccisd-laravel-assignment/dist/components/navigations/withModules';
import courseWrapper from 'cccisd-laravel-assignment/dist/components/navigations/courseWrapper';
import sessionDataEntry from 'cccisd-laravel-assignment/dist/components/navigations/sessionDataEntry';
import outcomesDataEntry from 'cccisd-laravel-assignment/dist/components/navigations/outcomesDataEntry';

const navigations = [withModules, courseWrapper, sessionDataEntry, outcomesDataEntry];

export default navigations;
